import type {
  EditPreSeasonAggregationCriteriaSelection,
  EditPreSeasonAggregationRequestBody,
  EditPreSeasonAggregationSingleSelection,
  FrontendAssortmentDimensionAttributeAggregation,
  FrontendAssortmentRowDimensionIdentifier,
} from '../types';

import { isConcreteDimensionIdentifier } from './map-row-dimension-to-identifier';
import { transformDimensionAttributes } from './transform-dimensions';

type FrontendIncludeListSelection = Omit<
  EditPreSeasonAggregationSingleSelection,
  'include_list'
> & {
  include_list: FrontendAssortmentRowDimensionIdentifier[][];
};

type FrontendCriteriaSelection = Omit<
  EditPreSeasonAggregationCriteriaSelection,
  'exclude_list'
> & {
  exclude_list?: FrontendAssortmentRowDimensionIdentifier[][];
};

type RequestBody = Omit<
  EditPreSeasonAggregationRequestBody,
  'dimensions' | 'selection'
> & {
  dimensions: FrontendAssortmentDimensionAttributeAggregation;
  selection: FrontendIncludeListSelection | FrontendCriteriaSelection;
};

const transformIdentifiers = (
  identifiers: FrontendAssortmentRowDimensionIdentifier[][],
) => identifiers.map((row) => row.filter(isConcreteDimensionIdentifier));

export const transformEditPreSeasonAggregationRequest = (
  body: RequestBody,
): EditPreSeasonAggregationRequestBody => {
  const { dimensions, selection, ...rest } = body;
  const transformedDimensions = transformDimensionAttributes(dimensions);

  if (selection.selection_type === 'include_list') {
    return {
      ...rest,
      dimensions: transformedDimensions,
      selection: {
        ...selection,
        include_list: transformIdentifiers(selection.include_list),
      },
    };
  }

  return {
    ...rest,
    dimensions: transformedDimensions,
    selection: {
      ...selection,
      exclude_list: selection.exclude_list
        ? transformIdentifiers(selection.exclude_list)
        : undefined,
    },
  };
};
